var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b({}, "div", _vm.fullScreenParentProps, false),
    [
      _vm.fullScreen
        ? _c("a-icon", {
            staticClass: "full-screen-icon",
            attrs: { type: _vm.iconType },
            on: { click: () => (_vm.fullCoder = !_vm.fullCoder) },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "code-editor-cust full-screen-child" },
        [
          _c("a-textarea", {
            style: {
              "max-height": _vm.maxHeight + "px",
              "min-height": _vm.minHeight + "px",
            },
            attrs: { "auto-size": "", placeholder: _vm.placeholderShow },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.textareaValue,
              callback: function ($$v) {
                _vm.textareaValue = $$v
              },
              expression: "textareaValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }